<h2 mat-dialog-title class="bg-blue text-white">PEO API Credentials</h2>
<mat-dialog-content>
  <p>
    Use the form below to fill out the API Credential information for the {{ peoId }} PEO.
  </p>
  <form [formGroup]="form" class="app-form">

    <fieldset>

      <!-- PrismHR API Username -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Username</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.username"
               placeholder="SYNCSTREAMSSO">
        <mat-error *ngIf="form.controls.username?.hasError('required')">
          A PrismHR API Username is required.
        </mat-error>
      </mat-form-field>

      <!-- PrismHR API Password -->
      <mat-form-field class="app-form-field-half" floatLabel="always">
        <mat-label>Password</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.password"
               [type]="hidePassword ? 'password' : 'text'" placeholder="s0m3Sup3rS3cr3t!">
        <button mat-icon-button matSuffix matTooltip="Toggle password visibility."
                aria-label="Toggle password visibility." (click)="togglePasswordVisibility()">
          <mat-icon *ngIf="hidePassword">visibility</mat-icon>
          <mat-icon *ngIf="!hidePassword">visibility_off</mat-icon>
        </button>
        <mat-error *ngIf="form.controls.password?.hasError('required')">
          A PrismHR API Password is required.
        </mat-error>
      </mat-form-field>
    </fieldset>

    <fieldset>
      <!-- PrismHR API URL -->
      <mat-form-field class="app-form-field-whole"
                      floatLabel="always" style="display: block;">
        <mat-label>API URL</mat-label>
        <input matInput [disabled]="formDisabled" [formControl]="form.controls.url"
               placeholder="https://host.domain.tld/path">
        <mat-error *ngIf="form.controls.url?.hasError('required')">
          A PrismHR API URL is required.
        </mat-error>
      </mat-form-field>
    </fieldset>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="testing">
    <mat-icon>cancel</mat-icon>
    Cancel
  </button>

  <button mat-button (click)="test()" [color]="tested ? testedSuccessfully ? 'icon-green' : 'icon-red' : 'icon-orange'"
          [disabled]="form.invalid || formDisabled"
          matTooltip="Test the API Credentials directly against the PrismHR API.">
    <mat-icon *ngIf="!testing && !tested">api</mat-icon>
    <mat-icon *ngIf="!testing && tested && testedSuccessfully">check</mat-icon>
    <mat-icon *ngIf="!testing && tested && !testedSuccessfully">report</mat-icon>
    <mat-icon *ngIf="testing">
      <mat-spinner color="warn" diameter="20"></mat-spinner>
    </mat-icon>
    <span *ngIf="!testing && !tested">Test</span>
    <span *ngIf="!testing && tested && testedSuccessfully">Tested</span>
    <span *ngIf="testing">Testing</span>
    <span *ngIf="!testing && tested && !testedSuccessfully">Re-Test</span>
  </button>

  <button mat-button (click)="save()" [disabled]="form.invalid || formDisabled || testing"
          [matTooltip]="testedSuccessfully ? 'Commit the API Credentials to persistent storage.' : 'Please test the API Credentials before saving.'"
          color="primary">
    <mat-icon>save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
